//Reducer Types
interface State {
  departmentList: any;
  departmentListByProduct: any;
  departmentCount: number;
  categoryList: any;
  categoryCount: number;
  hiredCompanyList: any;
  hiredCompanyCount: number;
  pricesheetVariablesInfo: any;
}

export const staticDataReducer = (
  state: State = {
    departmentList: [],
    departmentListByProduct: [],
    departmentCount: 0,
    categoryList: [],
    categoryCount: 0,
    hiredCompanyList: [],
    hiredCompanyCount: 0,
    pricesheetVariablesInfo: null,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_DEPARTMENT_DATA":
      return {
        ...state,
        departmentList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.departmentList, ...action.payload?.data],
        departmentCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "GET_DEPARTMENT_BY_PRODUCT_DATA":
      return {
        ...state,
        departmentListByProduct: action.payload,
      };

    case "UPDATE_DEPARTMENT_DATA":
      return {
        ...state,
        departmentList: state?.departmentList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_DEPARTMENT":
      return {
        ...state,
        departmentList: state?.departmentList?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        departmentCount: state?.departmentCount - 1,
      };
    case "GET_CATEGORY_DATA":
      return {
        ...state,
        categoryList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.categoryList, ...action.payload?.data],
        categoryCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "GET_HIRED_COMPANY_DATA":
      return {
        ...state,
        hiredCompanyList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.hiredCompanyList, ...action.payload?.data],
        hiredCompanyCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "DELETE_HIRED_COMPANY":
      return {
        ...state,
        hiredCompanyList: state?.hiredCompanyList?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        hiredCompanyCount: state?.hiredCompanyCount - 1,
      };
    case "UPDATE_HIRED_COMPANY_DATA":
      return {
        ...state,
        hiredCompanyList: state?.hiredCompanyList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "GET_PRICESHEET_VARIABLES_INFO":
      return {
        ...state,
        pricesheetVariablesInfo: action.payload,
      };
    case "UPDATE_PRICESHEET_VARIABLES_INFO":
      return {
        ...state,
        pricesheetVariablesInfo: action.payload,
      };

    default:
      return state;
  }
};
